/**
 * @generated SignedSource<<8fda3442b5b090fccd79b8c23d45da39>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraNavigationItemTypeKey = "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CODE" | "COMPONENTS" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INCIDENTS" | "ISSUES" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type AddTab_container$data = {
  readonly addableNavigationItemTypes?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly typeKey: JiraNavigationItemTypeKey | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly scopeId?: string;
  readonly " $fragmentType": "AddTab_container";
};
export type AddTab_container$key = {
  readonly " $data"?: AddTab_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddTab_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "name": "AddTab_container",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "scopeId"
          },
          "action": "THROW",
          "path": "scopeId"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            }
          ],
          "concreteType": "JiraNavigationItemTypeConnection",
          "kind": "LinkedField",
          "name": "addableNavigationItemTypes",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraNavigationItemTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "typeKey"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "type": "JiraContainerNavigation"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "e7a1677907497a682f7ad257faae81ad";

export default node;
